module.exports = __webpack_public_path__ + "static/media/AthleticTraining.2d08a59b.svg";